import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const SIDEBAR_EXPANDED_STORAGE_KEY: string = 'vinlivt-b2b-sidebar-expanded';

/**
 * Collapsed/expanded state of the left navigation, chosen by the advisor via the sidebar toggle.
 * `null` = no choice yet → the sidebar follows the viewport (expanded from 1400px).
 */
@Injectable({
  providedIn: 'root',
})
export class SidebarStateService {
  private readonly expandedPreference: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(
    this.readPreference(),
  );

  public getExpandedPreference(): Observable<boolean | null> {
    return this.expandedPreference.asObservable();
  }

  public setExpanded(expanded: boolean): void {
    this.expandedPreference.next(expanded);

    try {
      localStorage.setItem(SIDEBAR_EXPANDED_STORAGE_KEY, String(expanded));
    } catch {
      // localStorage unavailable (private mode / storage disabled) — keep the state for this session only
    }
  }

  private readPreference(): boolean | null {
    try {
      const stored: string | null = localStorage.getItem(SIDEBAR_EXPANDED_STORAGE_KEY);
      return stored === null ? null : stored === 'true';
    } catch {
      return null;
    }
  }
}
